export default class HeaderWidget {
    static element = null;
    static currentWidgetName = null;
    static isFirstOpening = true;

    static init() {
        this.element = document.getElementById('headerWidget');
        if (!this.element) {
            return;
        }

        HeaderWidget.initializeWeatherWidget();

        document.addEventListener('click', (event) => {
            const closestToggleButton = event.target.closest('[data-toggle-header-widget]');
            if (!closestToggleButton) {
                return;
            }

            const widgetName = closestToggleButton.dataset.toggleHeaderWidget || this.currentWidgetName;
            HeaderWidget.toggleWidget(widgetName);
        })
    }

    static async initializeWeatherWidget() {
        const weatherWidgetUri = this.element.dataset.weatherWidgetUri;
        const headerWidgetInner = this.element.querySelector('.header-widget__inner');
        if (!weatherWidgetUri) {
            return;
        }

        const response = await fetch(weatherWidgetUri);
        if (response.ok) {
            headerWidgetInner.innerHTML += await response.text();
        } else {
            console.warn('Weather widget could not be loaded')
        }
    }

    static toggleWidget(widgetName) {
        if (this.currentWidgetName) {
            this.element.querySelector(`.header-widget__pane--show`).classList.remove('header-widget__pane--show');
        }

        if (this.currentWidgetName === widgetName) {
            this.currentWidgetName = null;
            this.element.classList.remove('header-widget--open');
        } else {
            this.currentWidgetName = widgetName;
            const newWidget = this.element.querySelector(`.header-widget__pane[data-widget-name="${widgetName}"]`);
            newWidget.classList.add('header-widget__pane--show');
            this.element.classList.add('header-widget--open');
        }

        // there is this very weird bug in Chrome, that I don't understand. If you reload the page and open the contact widget first,
        // the position of the widget is wrong. Somehow it depend on the content height of the weather widget, whether the bug appears or not.
        if (this.isFirstOpening && widgetName === 'contact') {
            const newWidget = this.element.querySelector(`.header-widget__pane[data-widget-name="weather"]`);
            newWidget.classList.add('header-widget__pane--show');
            setTimeout(() => {
                newWidget.classList.remove('header-widget__pane--show');
            }, 100);
        }
        this.isFirstOpening = false;
    }
}
